import { LocaleProvider } from '@op/opds.opux';
import { DateTime } from 'luxon';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { APP_ELEMENT_ID } from './constants';
import EstimatorApp from './EstimatorApp';
import giosg from './giosg';
import { LoadingScreen } from './individual/views/LoadingScreen';
import reportWebVitals from './reportWebVitals';
import { isContentOnly, getProductParam, redirectTo } from './utils';
import { getCurrentLanguage } from 'i18n';

const { NODE_ENV } = process.env;

// Update currentDate for development mode (initial state is loaded from public/dev-initial-state.js in HTML)
if (
  (NODE_ENV === 'development' || NODE_ENV === 'test') &&
  !window.Cypress &&
  window.__RHVKLSO002_INITIAL_STATE
) {
  window.__RHVKLSO002_INITIAL_STATE.currentDate = DateTime.now().toISODate();
}

giosg.launchGiosgChat(
  window.__RHVKLSO002_CONFIG.GIOSG_ID,
  NODE_ENV === 'development',
  isContentOnly()
);

const container = document.getElementById(APP_ELEMENT_ID);
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
let app;

if (window.__RHVKLSO002_INITIAL_STATE.redirectToAuth) {
  const productParam = getProductParam();
  app = <LoadingScreen />;
  redirectTo(window.__RHVKLSO002_CONFIG.LIFEPURCHASE_AUTH_REDIRECT_URL, {
    product: productParam,
  });
} else if (window.__RHVKLSO002_INITIAL_STATE.appType === 'estimator') {
  app = <EstimatorApp />;
} else {
  app = <App />;
}

if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (console) {
        console.error(
          'Cannot remove a child from a different parent',
          child,
          this
        );
      }
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };
}

root.render(
  <React.StrictMode>
    <LocaleProvider locale={getCurrentLanguage()}>{app}</LocaleProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
